import React from 'react'
import Img from 'gatsby-image/withIEPolyfill'

const Image = ({ image, ...props }) =>
  image ? <Img className={`w-full rounded`} fluid={image} {...props} /> : null

export { Image }
